export const createGithubProfileURL = (username: string) => {
  return `https://github.com/${username}`;
};
